<template>
  <main class="retrait">
  <div class="col-sm-8 mx-auto">
    <h1 class="display-2">Retrait</h1><hr>
    <form @submit.prevent="onSubmit">
      <!--div class="form-group">
        <label class="" for="inlineCheckbox3">Balance</label>
        <input type="text" class="form-control" disabled='disabled' :value="$store.getters.loggedAs.solde">
      </div>
      <div class="form-group">
        <label class="" for="inlineCheckbox3">Destination</label>
        <input type="text" class="form-control">
      </div-->
      <div class="form-group">
        <label class="" for="inlineCheckbox3">Montant</label>
        <input type="text" class="form-control" v-model="payload.amount">
      </div>
      <div class="form-group">
        <label class="" for="inlineCheckbox3">Taux</label>
        <input type="text" class="form-control" disabled='disabled' value="5%">
      </div>
      <div class="form-group">
        <label class="">Total</label>
        <input type="text" class="form-control" disabled='disabled' :value="0.95*payload.amount">
      </div>
      <div class="form-group">
        <label class="" for="inlineCheckbox3">Equivalance</label>
        <div class="input-group">
          <input type="text" class="form-control" disabled='disabled' v-model="payload.amount">
          <div class="input-group-prepend">
            <select class="custom-select mr-sm-2" id="inlineFormCustomSelect">
              <option value="1">EUR</option>
              <option value="1">USD</option>
              <option value="2">GBP</option>
              <option value="3">XOF</option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="form-check form-check-inline" v-for="(tier, index) in tiers" :key="index">
          <input class="form-check-input" type="radio" :value="tier" v-model="payload.tierp">
          <img :src="path(tier)" class="img-fluid">
        </div>
      </div>
      <div class="form-group">
        <label class="">Code de transfert</label>
        <input type="password" class="form-control" v-model="payload.code" autocomplete>
      </div>
      <div class="form-group">
        <button type="submit" :class="[{ 'disabled': loading }, 'btn btn-warning btn-lg']">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading"></span>
          Valider
        </button>
      </div>
    </form>
    </div>
  </main>
</template>

<script>

export default {
  name: 'retrait',
  data() {
    return {loading: false, payload: {type: 'retrait', amount: 0}}
  },
  computed: {
    tiers() {
      return this.$store.getters['resource/TIERS']
    }
  },
  methods: {
    path(v) {
      return require(`../../assets/img/${v.type=='PayPal' ? 'paypal': v.type=='VisArd' ? 'visa': 'mastercard'}.png`);
    },
    onSubmit() { 
      this.loading = true;
      this.$store.dispatch('transact/insertTrans', this.payload).then(
        () => {
          this.payload = {type: 'retrait', amount: 0}; 
          this.loading = false
        }
      )
    }
  },
}
</script>

<style scoped lang="scss">

</style>
